import {  Container, TextField } from "@material-ui/core";
import React from "react";

function SearchList({ handleChange, searchTerm }) {
  return (
    <Container >
      <TextField
        id="standard-full-width"
       
        placeholder="Search Invoice No"
      
        fullWidth
        margin="normal"
        InputLabelProps={{
          shrink: true,
        }}
        value={searchTerm}
        onChange={handleChange}
      />
    </Container>
  );
}

export default SearchList;
